// src/store/slices/authSlice.js
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  user: JSON.parse(localStorage.getItem("user")) || null,
  token: localStorage.getItem("token") || null,
  refreshToken: localStorage.getItem("refreshToken") || null,
  isAuthenticated: !!localStorage.getItem("token"),
  isLoading: false,
  error: null,
  isFirstLogin: localStorage.getItem("isFirstLogin") === "true",
  employee: JSON.parse(localStorage.getItem("employee")) || null,
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    loginStart: (state) => {
      state.isLoading = true;
      state.error = null;
    },
    loginSuccess: (state, action) => {
      const { user, token, refreshToken, isFirstLogin, employee } =
        action.payload;
      state.isLoading = false;
      state.isAuthenticated = true;
      state.user = user;
      state.token = token;
      state.refreshToken = refreshToken;
      state.isFirstLogin = isFirstLogin;
      state.employee = employee;
      
      // Persist
      localStorage.setItem("user", JSON.stringify(user));
      localStorage.setItem("token", token);
      localStorage.setItem("refreshToken", refreshToken);
      localStorage.setItem("employee", JSON.stringify(employee));
      localStorage.setItem("isFirstLogin", isFirstLogin ? "true" : "false");
    },
    loginFailure: (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
    },
    setFirstLogin: (state, action) => {
      state.isFirstLogin = action.payload;
      localStorage.setItem("isFirstLogin", action.payload ? "true" : "false");
    },
    // logout: () => {
    //   localStorage.removeItem('user');
    //   localStorage.removeItem('token');
    //   localStorage.removeItem('refreshToken');
    //   localStorage.removeItem('employee');
    //   localStorage.removeItem('isFirstLogin');
    //   return initialState;
    // },

    logout: () => {
      // ---- 1. Clear EVERYTHING from localStorage ----
      localStorage.removeItem("user");
      localStorage.removeItem("token");
      localStorage.removeItem("refreshToken");
      localStorage.removeItem("employee");
      localStorage.removeItem("isFirstLogin"); // ← THIS WAS MISSING

      // ---- 2. Return a clean initial state (no stale data) ----
      return {
        user: null,
        token: null,
        refreshToken: null,
        isAuthenticated: false,
        isLoading: false,
        error: null,
        isFirstLogin: false, // ← explicitly false
        employee: null,
      };
    },
  },
});

export const { loginStart, loginSuccess, loginFailure, setFirstLogin, logout } =
  authSlice.actions;
export default authSlice.reducer;
